module.exports = __webpack_public_path__ + "static/media/ctrip-logo-1.5bbb8089.jpg";